<template>
  <div v-if="!isCookieAgreed" class="coocke-bar-sec">
    <section class="container">
      <div class="container">
        <div class="row">
          <div class="col col-md-12">
            <div class="cookie-content-wrap">
              <div class="cooki-logo">
                <img :src="require(`@/base/assets/imgs/brand.png`)" alt="" />
              </div>
              <div class="cookie-content">
                <h3 class="semiBold-15">
                  {{ $t("cookiebar_title") }}
                </h3>
                <p class="regular-12">
                  {{ $t("cookiebar_text") }}
                </p>
                <div class="accept-check-box-btn">
                  <div class="accept-checkboxes-wrap">
                    <div class="c-checkbox">
                      <input type="checkbox" name="check01" checked disabled />
                      <label class="regular-12">{{
                        $t("cookiebar_necessary")
                      }}</label>
                    </div>
                    <div class="c-checkbox">
                      <input
                        type="checkbox"
                        v-model="allCookies"
                        name="check02"
                      />
                      <label class="regular-12">{{
                        $t("cookiebar_other")
                      }}</label>
                    </div>
                  </div>
                  <button class="c-btn c-btn-primary" @click="onClick">
                    {{ $t("cookiebar_accept") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "CookieBarWrap",
  components: {},

  data() {
    return {
      allCookies: true,
      isCookieAgreed: this.$cookies.isKey("websiteCookie"),
    };
  },
  methods: {
    onClick() {
      this.isCookieAgreed = true;
      this.$cookies.config("180d");
      this.$cookies.set("websiteCookie", this.allCookies);
      if (this.allCookies == true) {
        this.updateGoogleConsent("granted");
      } else {
        this.updateGoogleConsent("denied");
      }
    },
    setGoogleConsent(consent) {
      if (typeof window.gtag !== "function") {
        window.gtag = function () {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(arguments);
        };
      }
      window.gtag("consent", "default", this.formatConsent(consent));
    },
    updateGoogleConsent(consent) {
      window.gtag("consent", "update", this.formatConsent(consent));
    },
    formatConsent(consent) {
      return {
        ad_storage: consent,
        analytics_storage: consent,
        functionality_storage: consent,
        personalization_storage: consent,
        security_storage: "granted",
        ad_user_data: consent,
        ad_personalization: consent,
        wait_for_update: 2000,
      };
    },
  },
  mounted() {
    this.setGoogleConsent("denied");
    this.$gtm.enable(true);
    if (this.allCookies && this.isCookieAgreed) {
      this.updateGoogleConsent("granted");
    } else {
      this.updateGoogleConsent("denied");
    }
  },
};
</script>

<style>
</style>
